import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getCurrentTime16j9973nx5x63 as getCurrentTime } from './internal/KLoggingClock.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KLoggingEventClass;
function KLoggingEvent() {
  if (KLoggingEventClass === VOID) {
    class $ {
      static s2g(level, marker, loggerName, message, cause, payload, timestamp) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        payload = payload === VOID ? null : payload;
        timestamp = timestamp === VOID ? getCurrentTime() : timestamp;
        var $this = createThis(this);
        $this.z2f_1 = level;
        $this.a2g_1 = marker;
        $this.b2g_1 = loggerName;
        $this.c2g_1 = message;
        $this.d2g_1 = cause;
        $this.e2g_1 = payload;
        $this.f2g_1 = timestamp;
        return $this;
      }
      static t2g(level, marker, loggerName, eventBuilder) {
        return this.s2g(level, marker, loggerName, eventBuilder.k2g_1, eventBuilder.l2g_1, eventBuilder.m2g_1);
      }
      toString() {
        return 'KLoggingEvent(level=' + this.z2f_1.toString() + ', marker=' + toString(this.a2g_1) + ', loggerName=' + this.b2g_1 + ', message=' + this.c2g_1 + ', cause=' + toString(this.d2g_1) + ', payload=' + toString(this.e2g_1) + ', timestamp=' + this.f2g_1.toString() + ')';
      }
      hashCode() {
        var result = this.z2f_1.hashCode();
        result = imul(result, 31) + (this.a2g_1 == null ? 0 : hashCode(this.a2g_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.b2g_1) | 0;
        result = imul(result, 31) + (this.c2g_1 == null ? 0 : getStringHashCode(this.c2g_1)) | 0;
        result = imul(result, 31) + (this.d2g_1 == null ? 0 : hashCode(this.d2g_1)) | 0;
        result = imul(result, 31) + (this.e2g_1 == null ? 0 : hashCode(this.e2g_1)) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.f2g_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KLoggingEvent()))
          return false;
        var tmp0_other_with_cast = other instanceof KLoggingEvent() ? other : THROW_CCE();
        if (!this.z2f_1.equals(tmp0_other_with_cast.z2f_1))
          return false;
        if (!equals(this.a2g_1, tmp0_other_with_cast.a2g_1))
          return false;
        if (!(this.b2g_1 === tmp0_other_with_cast.b2g_1))
          return false;
        if (!(this.c2g_1 == tmp0_other_with_cast.c2g_1))
          return false;
        if (!equals(this.d2g_1, tmp0_other_with_cast.d2g_1))
          return false;
        if (!equals(this.e2g_1, tmp0_other_with_cast.e2g_1))
          return false;
        if (!(this.f2g_1 === tmp0_other_with_cast.f2g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KLoggingEvent');
    KLoggingEventClass = $;
  }
  return KLoggingEventClass;
}
//region block: exports
export {
  KLoggingEvent as KLoggingEvent3el01063mcenm,
};
//endregion

//# sourceMappingURL=KLoggingEvent.mjs.map
